export default "__VITE_ASSET__1yoyywmn__"